import * as React from 'react';
import type { FilterItem, FilterRootItem } from '../../../types/Filter';
import { renderFilterView } from './views';

type Props = {
    filters: FilterRootItem | undefined;
    allAvailableFilters: FilterItem[];
    onChange?: { (filters: FilterRootItem): void };
    className?: string;
    selectedLocale?: string | null;
    isOrEnabled?: boolean;
};

const FiltersView = (props: Props) => {
    if (!props.filters) {
        return null;
    }
    return (
        <div className={props.className}>
            {renderFilterView({
                item: props.filters,
                index: 0,
                indent: 0,
                selectedLocale: props.selectedLocale ?? null,
                availableFilters: props.filters.availableFilters,
                allAvailableFilters: props.allAvailableFilters,
                availableGroupingFilter: {
                    and: true,
                    or: props.isOrEnabled ?? false
                },
                onChange: (filterItem) => {
                    if (filterItem?.type === 'and' || filterItem?.type === 'or') {
                        props.onChange?.(filterItem);
                    }
                }
            })}
        </div>
    );
};

export default FiltersView;
